import * as React from "react";
import { Admin, Resource, combineDataProviders, ListGuesser, EditGuesser} from "react-admin";
import buildRestProvider from 'ra-data-simple-rest';
import jsonServerProvider from "ra-data-json-server";
import { UserList } from "./UsersList";
import { DeviceList, DeviceEdit, DeviceShow } from "./DeviceList";
import { TaskList } from "./TaskList";
import { DeviceEventList, DeviceEventShow } from "./DeviceEventList";
import { FirmwareList, FirmwareCreate } from "./FirmwareList";
import { PatchList, PatchCreate } from "./PatchList";
import { ConfigTemplateList, ConfigTemplateCreate, ConfigTemplateEdit } from "./ConfigTemplateList";
//import PostIcon from "@material-ui/icons/Book";
import Dashboard from "./Dashboard";
import authProvider from "./authProvider";
import devicesDataProvider from "./devicesDataProvider";
import tasksDataProvider from "./tasksDataProvider";
import deviceEventsDataProvider from "./deviceEventsDataProvider";
import firmwaresDataProvider from "./firmwaresDataProvider";
import patchesDataProvider from "./patchesDataProvider";
import configTemplatesDataProvider from "./configTemplatesDataProvider";
import { apiBaseUrl } from "./config";

const dataProvider = combineDataProviders((resource) => {
	switch (resource) {
		case 'devices':
			return devicesDataProvider(apiBaseUrl);
		case 'tasks':
			return tasksDataProvider(apiBaseUrl);
		case 'device-events':
			return deviceEventsDataProvider(apiBaseUrl);
		case 'firmwares':
			return firmwaresDataProvider(apiBaseUrl);
		case 'patches':
			return patchesDataProvider(apiBaseUrl);
		case 'config_templates':
			return configTemplatesDataProvider(apiBaseUrl);
		default:
			throw new Error(`Unknown resource: ${resource}`);
	}
});

//const dataProvider = jsonServerProvider("https://jsonplaceholder.typicode.com");
const App = () => (
  <Admin
    dashboard={Dashboard}
    authProvider={authProvider}
    dataProvider={dataProvider}
  >
    <Resource
      name="devices"
      list={DeviceList}
      show={DeviceShow}
    />
    <Resource
      name="tasks"
      list={TaskList}
    />
    <Resource
      name="device-events"
      options={{ label: "Device Events" }}
      list={DeviceEventList}
      show={DeviceEventShow}
    />
    <Resource
      name="firmwares"
      list={FirmwareList}
      create={FirmwareCreate}
    />
    <Resource
      name="patches"
      list={PatchList}
      create={PatchCreate}
    />
    <Resource
      name="config_templates"
      options={{ label: "Configuration Templates" }}
      list={ConfigTemplateList}
      create={ConfigTemplateCreate}
      edit={ConfigTemplateEdit}
    />
  </Admin>
);

export default App;
